import type { ErrorRegistryShape } from '../common/common.error';

export const PORTFOLIO_REPORT_ERROR = {
  NOT_FOUND_PORTFOLIO_REPORT: { status: 404, message: 'Portfolio report not found' },
  /** 같은 포트폴리오에 같은 (연도, 분기) 리포트는 하나 */
  CONFLICT_PORTFOLIO_REPORT_DUPLICATE: {
    status: 409,
    message: 'Report for the quarter already exists',
  },
  /** 지울 수 있는 것은 마지막 분기 리포트뿐이다(다음 분기가 이 값을 이어받았을 수 있다) */
  CONFLICT_PORTFOLIO_REPORT_NOT_LATEST: {
    status: 409,
    message: 'Only the latest report can be deleted',
  },
  /** 포트폴리오 사용자는 LP 에게 공개된 리포트를 지울 수 없다 */
  FORBIDDEN_PORTFOLIO_REPORT_PUBLISHED: {
    status: 403,
    message: 'Published report can be deleted only by D3',
  },
  /**
   * 포트폴리오 사용자가 D3 만 쓰는 칸(D3 코멘트 · 성장성 · 런웨이 · 등급)을 보냈다.
   * data.fields = 거절한 칸(`items[0].d3Grade` …)
   */
  FORBIDDEN_PORTFOLIO_REPORT_D3_FIELDS: {
    status: 403,
    message: 'D3 fields can be written only by D3',
  },
  /**
   * 저장하는 사이 참조한 자료가 바뀌었다(예: 같은 때 KPI 가 지워짐). 새로 불러온 뒤 다시 저장한다.
   * 리포트끼리의 동시 저장은 포트폴리오 단위로 줄 세워 이 코드가 나지 않는다
   */
  CONFLICT_PORTFOLIO_REPORT_CHANGED: {
    status: 409,
    message: 'Report data changed while saving',
  },
  /** 회수 보고를 쓸 수 없다(종료 전이거나 종료 분기 리포트가 없음) */
  CONFLICT_EXIT_REPORT_NOT_WRITABLE: {
    status: 409,
    message: 'Exit report is not writable',
  },
} as const satisfies ErrorRegistryShape;
